import { NODE_WIDTH } from '../constants/csmlLayout';

export const GUIDE_THRESHOLD = 6;

// A node lines up with another on its left edge or its centre line (columns),
// or on its top edge (rows). Every node is NODE_WIDTH wide, so the two
// vertical candidates are the same for the dragged node and its neighbours.
const columnCandidates = x => [x, x + NODE_WIDTH / 2];

const closest = (value, candidates) =>
  candidates.reduce(
    (best, target) => {
      const distance = Math.abs(target - value);
      return distance < best.distance ? { target, distance } : best;
    },
    { target: null, distance: Infinity }
  );

/**
 * Finds where a node being dragged to (x, y) should snap to line up with the
 * other nodes. Returns the snapped coordinates (null when nothing is within
 * GUIDE_THRESHOLD on that axis) plus the guide line positions to draw.
 */
export function computeGuides(nodes, draggedIds, x, y) {
  const others = nodes.filter(node => ![draggedIds].flat().includes(node.id));
  const result = { x: null, y: null, vertical: [], horizontal: [] };

  let bestColumn = { distance: GUIDE_THRESHOLD + 1 };
  columnCandidates(x).forEach((own, ownIdx) => {
    others.forEach(other => {
      const hit = closest(own, columnCandidates(other.x));
      if (hit.distance < bestColumn.distance) {
        bestColumn = { ...hit, offset: own - x, ownIdx };
      }
    });
  });
  if (bestColumn.distance <= GUIDE_THRESHOLD) {
    result.x = bestColumn.target - bestColumn.offset;
    result.vertical.push(bestColumn.target);
  }

  const bestRow = others.reduce(
    (best, other) => {
      const distance = Math.abs(other.y - y);
      return distance < best.distance ? { target: other.y, distance } : best;
    },
    { target: null, distance: Infinity }
  );
  if (bestRow.distance <= GUIDE_THRESHOLD) {
    result.y = bestRow.target;
    result.horizontal.push(bestRow.target);
  }

  return result;
}
